import axios from 'axios';

export interface Review {
  author_name: string;
  profile_photo_url: string;
  rating: number;
  text: string;
  time: number;
}

export interface ReviewsResponse {
  rating: number;
  reviews: Review[];
}

export const getReviews = async (): Promise<ReviewsResponse> => {
  try {
    const response = await axios.get('https://backend.clinicaestimapet.com.br/api/reviews');
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar avaliações');
  }
}; 